import dateHelper from '../../util/date'

var common = {
  /**
   * 调用下一个函数
   * @param {*} vm
   * @param {*} funcList
   */
  callNextFunc: function (vm, funcList) {
    //除去数组头, 如果数组长度为0则取消调用, 小于0则继续
    funcList.splice(0, 1)
    if (funcList.length != 0) {
      vm.$emit(funcList[0].funcName, vm, funcList)
    }
  },

  compareForBottomNav: function compare(p) {
    //这是比较函数
    return function (m, n) {
      var a = m[p]
      var b = n[p]
      return a - b //升序
    }
  },

  // 计算过滤时间
  convertFilterDate: function (dispData) {
    var timestampDate = []
    if (dispData != null && dispData != '') {
      switch (dispData) {
        case '全部':
          break

        case '今天':
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(0))
          )
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(1))
          )
          break

        case '明天':
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(1))
          )
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(2))
          )
          break

        case '昨天':
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(-1))
          )
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(0))
          )
          break

        case '近3天内':
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(-3))
          )
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(4))
          )
          break

        case '近10天内':
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(-10))
          )
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(11))
          )
          break

        case '近30天内':
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(-30))
          )
          timestampDate.push(
            dateHelper.date2Timestamp(dateHelper.getDayAfterToday(31))
          )
          break
      }
    }
    return timestampDate
  },

  JudgeFileType(fileName) {
    return fileName.indexOf('.mp4') != -1 ? 'video' : 'image'
  },
}

export default common
